// @flow

import ajax from 'services/ajax/ajax';
import url from '@active/awe-ui-core/lib/services/url';
import type { MapSuccess, MapFailure } from 'type/type';

export const searched = (
  param: { q: string, offset: number, limit: number, portalId: ?string },
  mapSuccess: MapSuccess,
  mapFailure: ?MapFailure,
) => {
  const {
    q, offset, limit, portalType, portalId,
  } = param;
  const searchUrl = portalType && portalId ? `/results/search/${portalType}/${portalId}/events` : '/results/search/events';
  return ajax.get(
    url(searchUrl)
      .appendParam('q', q)
      .appendParam('offset', offset)
      .appendParam('limit', limit)
      .value(), {
      mapSuccess,
      mapFailure,
    });
};

export const list = (
  params: {q: string, offset: number, limit: number},
  mapSuccess: MapSuccess,
  mapFailure: ?MapFailure,
) => ajax.get(
  url('/results/search/persons')
    .appendParam('q', params.q)
    .appendParam('offset', params.offset)
    .appendParam('limit', params.limit)
    .value(), {
    mapSuccess,
    mapFailure,
  });
